import { ArnTrackingService } from './ArnTrackingService';
import { MatomoTrackingService } from './matomo/MatomoTrackingService';
import { GoogleAnalyticsService } from './google/GoogleAnalyticsService';
import { SentryTrackingService } from './sentry/SentryTrackingService';

export class DefaultArnTrackingService implements ArnTrackingService {
  matomo: MatomoTrackingService;
  googleAnalytics: GoogleAnalyticsService;
  sentry: SentryTrackingService;

  constructor(readonly trackers: ArnTrackingService) {
    this.matomo = trackers.matomo || {};
    this.googleAnalytics = trackers.googleAnalytics || {};
    this.sentry = trackers.sentry || {};
  }
}
